import * as React from 'react';

import { Button } from 'antd';

import { Field, useFormikContext } from 'formik';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { SelectProduct } from 'v2/components/Shared/FormFields/SelectProduct';
import TextFormField from 'v2/components/Shared/FormFields/TextFormField';

import { Icon } from '@eduzz/ui-antd-theme';

export enum HistoryStatus {
  PENDING = 'pending',
  ARCHIVED = 'archived',
  SUCCESS = 'success',
  FAILED = 'failed'
}

export const FilterWebhookHistory = () => {
  const { resetForm, submitForm } = useFormikContext();

  const handleResetForm = () => {
    resetForm();
    submitForm();
  };

  return (
    <div className='flex flex-col gap-4'>
      <div className='grid grid-cols-1 gap-4 md:grid-cols-3'>
        <Field label='Data de envio' id='date' name='date' fullWidth component={DateRangePickerFormField} />

        <Field
          id='webhook-historic-product'
          name='product_id'
          label='Produtos'
          fullWidth
          component={SelectProduct}
          endpoint='reports/filter-all-products?exclude_affiliations=1'
        />

        <Field
          id='webhook-historic-customer'
          name='customer'
          label='Comprador'
          placeholder='Pesquise por nome ou email'
          fullWidth
          component={TextFormField}
        />
      </div>

      <div className='grid grid-cols-1 gap-4 md:grid-cols-12'>
        <div className='md:col-span-3'>
          <Field
            id='entityId'
            name='entityId'
            component={TextFormField}
            fullWidth
            label='Fatura/Contrato'
            type='tel'
            placeholder='Pesquise por fatura ou contrato'
          />
        </div>

        <div className='md:col-span-5'>
          <Field
            id='webhook-historic-status'
            name='status'
            label='Status'
            fullWidth
            component={SelectFormField}
            multiple
            options={[
              { label: 'Enviado', value: HistoryStatus.SUCCESS },
              { label: 'Retornou erro', value: HistoryStatus.FAILED },
              { label: 'Pendente', value: HistoryStatus.PENDING },
              { label: 'Arquivado', value: HistoryStatus.ARCHIVED }
            ]}
          />
        </div>

        <div className='flex items-end justify-end gap-2 md:col-span-4'>
          <Button type='text' onClick={handleResetForm} icon={<Icon.X size={16} />}>
            Limpar filtros
          </Button>
          <Button type='primary' htmlType='submit' icon={<Icon.Funnel size={16} />}>
            Filtrar
          </Button>
        </div>
      </div>
    </div>
  );
};
